<app-header-style-two></app-header-style-two>

<div class="page-title-area item-bg4">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Accueil</a></li>
                <li>Evènements</li>
            </ul>
            <h2>Nos évènements</h2>
        </div>
    </div>
</div>

<div class="events-area pt-100 pb-70">
    <div class="container">
        <div *ngFor="let element of events; let i = index" class="single-events-box mb-30">
            <div class="events-box">
                <div class="events-image">
                    <div class="image bg1">
                        <img src="{{element.mainBanner}}" alt="image">
                    </div>
                </div>
                <div class="events-content">
                    <div class="content">
                        <h3><a routerLink="/detail-event/{{element.code}}">{{element.title}}</a></h3>
                        <p style="text-align: justify;" >{{element.shortDescription}}</p>
                        <!-- <span class="location"><i class='bx bx-map'></i> 120 G-35 Spinsovila Sc, USA</span>
                        <a routerLink="/single-events" class="join-now-btn">Join Now</a> -->
                    </div>
                </div>
                <div class="events-date">
                    <div class="date">
                        <div class="d-table">
                            <div class="d-table-cell">
                                <span>{{i+1}}</span>
                                <h3 *ngIf="element.nextEventDate !== '#na'">{{element.nextEventDate}}</h3>
                                <p *ngIf="element.nextEventHour !== '#na'">{{element.nextEventHour}}</p>
                                <i class='bx bx-calendar'></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>